import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

/** Grey rounded panel with an optional title — same look as the time-range-picker (e.g. Best Contact Time). */
@Component({
  selector: 'formly-panel-wrapper',
  template: `
    <div class="field-panel">
      <span *ngIf="props.label" class="section-title">{{ props.label }}</span>
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  styles: [
    `
      .field-panel {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 1rem;
        margin: 0 0 1rem 0;
        padding: 0.4rem 0.75rem 0 0.75rem;
      }
      .section-title {
        display: block;
      }
    `,
  ],
})
export class PanelWrapper extends FieldWrapper {}
